import { SmartMTAlert } from "./_components";
import { getBlobUrl, getImgBlob, navigateEdits, redoEdits, setImgBlob, undoEdit, clearHistory } from "./_utils";

var $ = jQuery;

/**
 * SmartMT editor popup.
 * @returns The HTML markups for SmartMT popup.
 * @param {string} content The HTML markup for the popup content.
 * @param {string} sidebar The HTML markup for the popup sidebar.
 */
export const SmartMTEditorPopup = (content, sidebar) => {
    const PopupHeader = `
        <div id="smart-mt-popup-header">
            <div class="smart-mt-tools">
                <button class="button" id="smart-mt-crop">
                    <span class="dashicons dashicons-image-crop"></span>Crop
                </button>
                
                <button class="button" id="smart-mt-resize">
                    <span class="dashicons dashicons-fullscreen-exit-alt"></span> Resize
                </button>

                <button class="button" id="smart-mt-rotate">
                    <span class="dashicons dashicons-image-rotate-left"></span> Rotate
                </button>

                <button class="button" id="smart-mt-effects">
                    <span class="dashicons dashicons-image-filter"></span> Effects
                </button>

                <button class="button" id="smart-mt-compress">
                    <span class="dashicons dashicons-media-archive"></span> Compress
                </button>

                <button class="button" id="smart-mt-convert">
                    <span class="dashicons dashicons-controls-repeat"></span> Convert
                </button>

            </div>
            <div class="smart-mt-popup-actions">
                <button class="smart-mt-icon-btn smart-mt-undo" disabled title="Undo"><span class="dashicons dashicons-undo"></span></button>
                <button class="smart-mt-icon-btn smart-mt-redo" disabled title="Redo"><span class="dashicons dashicons-redo"></span></button>
                <button class="button smart-mt-confirm-save" disabled>Save</button>
                <button class="button smart-mt-confirm-save-as" disabled>Save As New</button>
                <button class="button smart-mt-close smart-mt-danger">Cancel</button>
            </div>
        </div>`;

    let popup = `
        <div id="smartmt-editor-popup" class="smartmt">
            <div id="smart-mt-popup-wrapper">
                ${PopupHeader}
                <div id="smart-mt-popup-main">
                    <div id="smart-mt-popup-content">${content}</div>
                    <div id="smart-mt-popup-sidebar">${sidebar}</div>
                </div>
            </div>
        </div>`;

    if ($('#smartmt-editor-popup').length) {
        $('#smart-mt-popup-content').html(content);
        $('#smart-mt-popup-sidebar').html(sidebar);
    } else {
        $('body').append(popup);

        $('.smart-mt-tools .button').on('click', function () {

            let isActive = $(this).hasClass('active');

            $('.smart-mt-tools .button').removeClass('active');

            if (!isActive) {
                $(this).addClass('active');
            }
        });

        // Closing popup.
        $('.smart-mt-close').on('click', function () {
            $('#smartmt-editor-popup').remove();
            localStorage.removeItem('smart-mt-attachment');
            setImgBlob(null);
            delete window.SmartMT.currentIndex;
            clearHistory();
        });

        // Confirm save.
        $('.smart-mt-confirm-save').on('click', function () {
            SmartMTAlert(saveAlertContent, saveAlertBtns);
        });

        // Confirm save as.
        $('.smart-mt-confirm-save-as').on('click', function () {
            SmartMTAlert(saveAsAlertContent, saveAsAlertBtns);
        });

        // Undo
        $('.smart-mt-undo').on('click', function () {
            navigateEdits('undo');
        });

        // Redo
        $('.smart-mt-redo').on('click', function () {
            navigateEdits('redo');
        });
    }
};

const saveAlertContent = `
    <div class="smart-mt-alert-msg">This action will override the original file and cannot be undone, are you sure?</div>`;
const saveAlertBtns = `
    <button class="button" id="smart-mt-save"><span class="dashicons dashicons-saved"></span> Yes</button>
    <button class="button smart-mt-danger smart-mt-alert-close"><span class="dashicons dashicons-no-alt"></span> No</button>`;

const saveAsAlertContent = `
    <div class="smart-mt-alert-msg">This action will create a new file from your edits, the original file will remain untouched.</div>
    <div class="smart-mt-field-wrap">
        <label for="smart-mt-new-name">Enter new file name:</label>
        <div class="smart-mt-name-inputs">
            <input type="text" id="smart-mt-new-name" required>
            <input type="text" id="smart-mt-validated-new-name" disabled>
        </div>
    </div>
    <div id="smart-mt-error-display"></div>`;
const saveAsAlertBtns = `
    <button class="button" id="smart-mt-save-as"><span class="dashicons dashicons-saved"></span> Save</button>
    <button class="button smart-mt-danger smart-mt-alert-close"><span class="dashicons dashicons-no-alt"></span> Cancel</button>`;
